import React from 'react';
import { useNavigate } from 'react-router-dom';
import SplitViewport from '../components/SplitViewport';

const Home = () => {
  const navigate = useNavigate();

  const handleProfessionalClick = () => {
    navigate('/industrial/');
  };

  const handleHouseholdClick = () => {
    navigate('/household/');
  };

  return (
    <div className="relative min-h-screen overflow-hidden" style={{ 
      position: 'fixed',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      overscrollBehavior: 'none'
    }}>
      <SplitViewport
        leftImage="https://videos.ctfassets.net/hdznx4p7ef81/4bBm5VZIdxCP0jstaQKLB6/405885ebcbeb8e443ba0887395e5d1c2/Firefighter_Spray_Wipe_1.mp4"
        rightImage="https://videos.ctfassets.net/hdznx4p7ef81/1OG5dyWb0f3mWf05Dwjh0k/fbafd351797af80200e19a2cb6ef6e2c/housekeeping-products-hero-video.mp4"
        leftAlt="Industrial cleaning"
        rightAlt="Household cleaning"
        onProfessionalClick={handleProfessionalClick}
        onHouseholdClick={handleHouseholdClick}
      />
    </div>
  );
};

export default Home; 